"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineQuotaProcessor = void 0;
/**
 * The Quota Processor measures logging traffic for logs that match a specified filter. When the configured daily quota is met, the processor can drop or alert.
 */
class ObservabilityPipelineQuotaProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineQuotaProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineQuotaProcessor = ObservabilityPipelineQuotaProcessor;
/**
 * @ignore
 */
ObservabilityPipelineQuotaProcessor.attributeTypeMap = {
    dropEvents: {
        baseName: "drop_events",
        type: "boolean",
        required: true,
    },
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    ignoreWhenMissingPartitions: {
        baseName: "ignore_when_missing_partitions",
        type: "boolean",
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    limit: {
        baseName: "limit",
        type: "ObservabilityPipelineQuotaProcessorLimit",
        required: true,
    },
    name: {
        baseName: "name",
        type: "string",
        required: true,
    },
    overflowAction: {
        baseName: "overflow_action",
        type: "ObservabilityPipelineQuotaProcessorOverflowAction",
    },
    overrides: {
        baseName: "overrides",
        type: "Array<ObservabilityPipelineQuotaProcessorOverride>",
    },
    partitionFields: {
        baseName: "partition_fields",
        type: "Array<string>",
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineQuotaProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineQuotaProcessor.js.map